/*
 * Trinom Digital Pvt Ltd ("COMPANY") CONFIDENTIAL                             *
 * Copyright (c) 2024 Trinom Digital Pvt Ltd, All rights reserved              *
 *                                                                             *
 * NOTICE:  All information contained herein is, and remains the property      *
 * of COMPANY. The intellectual and technical concepts contained herein are    *
 * proprietary to COMPANY and may be covered by Indian and Foreign Patents,    *
 * patents in process, and are protected by trade secret or copyright law.     *
 * Dissemination of this information or reproduction of this material is       *
 * strictly forbidden unless prior written permission is obtained from         *
 * COMPANY. Access to the source code contained herein is hereby forbidden     *
 * to anyone except current COMPANY employees, managers or contractors who     *
 * have executed Confidentiality and Non-disclosure agreements explicitly      *
 * covering such access.                                                       *
 *                                                                             *
 * The copyright notice above does not evidence any actual or intended         *
 * publication or disclosure of this source code, which includes               *
 * information that is confidential and/or proprietary, and is a trade secret, *
 * of COMPANY. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC            *
 * PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE CODE        *
 * WITHOUT THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED,      *
 * AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE         *
 * RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES   *
 * NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS     *
 * CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,    *
 * IN WHOLE OR IN PART.                                                        *
 *                                                                             *
 * File: \src\mixins\checkTableConditionalValidations.js                       *
 * Project: frontend                                                           *
 * Created Date: Friday, June 14th 2024, 2:08:30 pm                            *
 * Author: Janani Priya <jananipriya@codestax.ai>                              *
 * -----                                                                       *
 * Last Modified: June 18th 2024, 3:40:39 pm                                   *
 * Modified By: Janani Priya                                                   *
 * -----                                                                       *
 * Any app that can be written in JavaScript,                                  *
 *     will eventually be written in JavaScript !!                             *
 * -----                                                                       *
 * HISTORY:                                                                    *
 * Date         By  Comments                                                   *
 * --------------------------------------------------------------------------- *
 */

export const checkTableConditionalValidations = {
    inheritAttrs: false,
    methods: {
        checkTableConditionalValidations(statement, rowValue) {
            let comparisonOperator;
            if (statement == true) {
              return true;
            }
            if (statement == undefined) {
              return false;
            }
            if (typeof statement == "object" && Object.keys(statement).length > 1) {
              let truthValues = [];
              for (var key in statement) {
                truthValues.push(this.getTableConditionalValue({ [key]: statement[key] }, rowValue));
              }
              return truthValues.every((v) => v === true);
            }
            for (var key in statement) {
              comparisonOperator = "";
              if (key instanceof Object && !Array.isArray(key)) {
                return this.getTableConditionalValue(key, rowValue);
              } else if (this.isLogicalOperator(key)) {
                if (key == "$and") {
                  return statement[key].every((v) => this.getTableConditionalValue(v) === true, rowValue);
                } else if (key == "$not") {
                  return !this.getTableConditionalValue(statement[key], rowValue);
                } else if (key == "$or") {
                  return statement[key].reduce(
                    (a, b) => this.getTableConditionalValue(b, rowValue) || this.getTableConditionalValue(a, rowValue)
                  );
                } else {
                  return false;
                }
              } else if (
                statement[key] instanceof Object &&
                Object.keys(statement[key]).length == 1 &&
                this.isComparisonOperator(Object.keys(statement[key])[0])
              ) {
                comparisonOperator = Object.keys(statement[key])[0];
                if (comparisonOperator == "$ne") {
                  return (
                    rowValue[key] != statement[key][comparisonOperator]
                  );
                } else if (comparisonOperator == "$in") {
                  return statement[key][comparisonOperator].includes(
                    rowValue[key]
                  );
                } else if (comparisonOperator == "$nin") {
                  return !statement[key][comparisonOperator].includes(
                    rowValue[key]
                  );
                } else if (comparisonOperator == "$lt") {
                  if (this.isNumeric(rowValue[key])) {
                    return (
                      Number(rowValue[key]) <
                      Number(statement[key][comparisonOperator])
                    );
                  }
                  return false;
                } else if (comparisonOperator == "$lte") {
                  if (this.isNumeric(rowValue[key])) {
                    return (
                      Number(rowValue[key]) <=
                      Number(statement[key][comparisonOperator])
                    );
                  }
                  return false;
                } else if (comparisonOperator == "$gt") {
                  if (this.isNumeric(rowValue[key])) {
                    return (
                      Number(rowValue[key]) >
                      Number(statement[key][comparisonOperator])
                    );
                  }
                  return false;
                } else if (comparisonOperator == "$gte") {
                  if (this.isNumeric(rowValue[key])) {
                    return (
                      Number(rowValue[key]) >=
                      Number(statement[key][comparisonOperator])
                    );
                  }
                  return false;
                } else {
                  return false;
                }
              } else if (
                typeof statement[key] == "boolean" ||
                typeof statement[key] == "string" ||
                (typeof statement[key] == "object" &&
                  statement[key].constructor === String) ||
                this.isNumeric(statement[key]) ||
                typeof statement[key] == "boolean"
              ) {
                return rowValue[key] == statement[key];
              } else {
                return false;
              }
            }
        },
        isNumeric(value) {
            return !isNaN(parseFloat(value)) && isFinite(value);
          },
          isLogicalOperator(value) {
            if (value == "$and" || value == "$not" || value == "$or") {
              return true;
            } else {
              return false;
            }
          },
          isComparisonOperator(value) {
            if (
              value == "$ne" ||
              value == "$in" ||
              value == "$nin" ||
              value == "$lt" ||
              value == "$lte" ||
              value == "$gt" ||
              value == "$gte"
            ) {
              return true;
            } else {
              return false;
            }
          },
    }
};
